import { useState } from 'react'

import { Box, Text, colors } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { ChevronDown, ChevronUp, Person } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { SkeletonValue } from 'modules/finance/components/FinancialWorkspace/components/SkeletonValue'

interface Props {
  count: number
  type: string
  loading: boolean
  details: React.ReactNode
}

export const CollapsableItem = ({ count, type, loading, details }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  return (
    <Box
      padding="s8"
      flexDirection="column"
      gap="s8"
      borderRadius={{ all: 'abs012' }}
      background={isOpen ? 'grey200' : 'grey000White'}
      onClick={handleClick}
    >
      <Box justifyContent="spaceBetween" flexDirection="row">
        <Box gap="s12" flexDirection="row" alignItems="center">
          <Box
            border={{ all: { width: 's1', style: 'solid', color: 'grey400' } }}
            style={{ color: colors.viridian1200 }}
            padding="s4"
            borderRadius={{ all: 'abs012' }}
            alignItems="center"
            justifyContent="center"
            background="viridian100"
          >
            <F0Icon icon={Person} size="lg" />
          </Box>

          {loading ? (
            <SkeletonValue />
          ) : (
            i18n.tView('finance.financial_workspace.employee_costs.workforce.contract', {
              count: (
                <Text.Normal size="200" weight="normal">
                  {count}
                </Text.Normal>
              ),
              type: (
                <Text.Normal size="200" weight="medium" capitalize>
                  {type}
                </Text.Normal>
              ),
            })
          )}
        </Box>

        <F0Icon icon={isOpen ? ChevronUp : ChevronDown} />
      </Box>

      {isOpen && details}
    </Box>
  )
}
